'use client';

import React from 'react';
import IslandSidebarMenu from '../IslandSidebarMenu';
import DynamicDrawer from '@components/DynamicDrawer';
import cn from './style.module.scss';

type MenuItem = {
  label: string;
  id: string;
  submenu?: MenuItem[];
};
type IslandSidebarDrawerProps = {
  navigationItems: MenuItem[];
};

export default function IslandSidebarDrawer({
  navigationItems,
}: IslandSidebarDrawerProps) {
  return (
    <DynamicDrawer
      drawerClassName={cn.islandSidebarDrawer}
      drawerBodyClassName={cn.islandSidebarBody}
      drawerContentClassName={cn.islandSidebarContent}
      closeBtnClassName={cn.islandSidebarClose}
      buttonClassName={cn.islandSidebarButton}
    >
      <IslandSidebarMenu navigationItems={navigationItems} />
    </DynamicDrawer>
  );
}
